var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ff8b8b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67 -307)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 36,
    height: 36,
    rx: 11,
    transform: "translate(67 307)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.995 311.837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.773,32.229V47.787H45.327V32.229a2.979,2.979,0,0,1,2.978-2.978h3.49A2.978,2.978,0,0,1,54.773,32.229Z",
    transform: "translate(-33.089 -16.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M54.924,14.242a3.923,3.923,0,1,1-7.846,0V13.183h7.846Z",
    transform: "translate(-34.04 -5.988)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.732,29.912l-1.717.294-.592-.748-3.356.574.194.816-1.718.294,4.438,8.842,7.19-1.232Zm-2.7,8.271-3.2-6.384,5.433-.931,3.2,6.384Z",
    transform: "translate(-18.542 -16.827)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.479,37.432l-3.754.643-.176-.351,3.755-.643Z",
    transform: "translate(-21.804 -20.967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.447,39.361,25.692,40l-.176-.351,3.754-.643Z",
    transform: "translate(-22.329 -22.014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.415,41.289l-3.754.643-.176-.351,3.754-.643Z",
    transform: "translate(-22.855 -23.061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.112,6.149H39.243V5.538h3.176a4.369,4.369,0,0,1,3.264-3.626,3.262,3.262,0,0,0-1.3,2.607h.533a2.736,2.736,0,0,1,2.354-2.706A4.366,4.366,0,0,1,51.112,6.149Z",
    transform: "translate(-29.784 0.187)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomImg);
export default __webpack_public_path__ + "static/media/room-img.cba49881f052e3ac66afde4438441f65.svg";
export { ForwardRef as ReactComponent };